import * as React from "react";
import TileImage from "../TileImage";
import TileContent from "../TileContent";
import {getPadding, getTileClasses} from "../TileMethods";

export const Overlayed = ({ data, height, settings, isMobile }) => {
    const paddingContent = getPadding(data);
    const tileClasses = getTileClasses(data, isMobile, paddingContent);
    
    // Check if image should be shown on mobile
    const shouldShowImage = !isMobile || (isMobile && data.settings.show_image_on_mobile !== false);

    const tileContent = (
        <div className={`tileitem z-[2] color-${data.color_schema} ${data.settings.padding_area == "outside" && paddingContent}`}>
            {shouldShowImage && (
                <TileImage data={data} height={height} isMobile={isMobile} />
            )}
            <div className={`tile__info ${(data.settings.image && shouldShowImage) ? "flex absolute w-full z-[5]" : ""} ${tileClasses}`}>
                <TileContent data={data} isMobile={isMobile} globals={settings.globals} />
            </div>
        </div>
    );

    return (
        <>
            {data.settings.make_tile_clickable ? (
                <div
                    onClick={() => (window.location.href = data.settings.button_url)}
                    className={`custom-class ${data.settings.main_aspect_ratio && data.settings.aspect_ratio_type }`}
                    style={{ cursor: "pointer", height: "100%", width: "100%" }}
                >
                    {tileContent}
                </div>
            ) : (
                tileContent
            )}
        </>
    );
};

export default Overlayed;
